import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-popup-submit',
  templateUrl: './popup-submit.component.html',
  styleUrls: ['./popup-submit.component.scss']
})
export class PopupSubmitComponent {
  isLoginInfo: boolean = false; 
  

  userInfo :any=localStorage.getItem("submitSrDetails");
  loginInfo: any = localStorage.getItem("userInfo");

  constructor(public dialog: MatDialog,private dialogRef: MatDialogRef<PopupSubmitComponent>) {
    this.userInfo = JSON.parse(this.userInfo);
    if(this.loginInfo){
   this.loginInfo = JSON.parse(this.loginInfo);
    this.isLoginInfo = this.loginInfo.isLoginInfo;
    }
 
  }
  
  

  onClose(): void {
    localStorage.setItem('ServiceTypeInfo','');
    localStorage.setItem('userInfo','');
    this.dialogRef.close();
    location.href='/';
  }
}
